import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: 'Save',
    error: 'Please enter your date of registration',
    title: 'Enter your date of registration',
  },
  fr: {
    cta: 'Enregistrer',
    error: 'Veuillez remplir votre date d’immatriculation',
    title: 'Saisissez votre date d’immatriculation',
  },
});

export default locales;
